var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44911 2.04547C5.06009 2.04547 2.31274 4.79281 2.31274 8.18183C2.31274 11.5709 5.06009 14.3182 8.44911 14.3182H10.1764C10.6308 14.3182 11.0736 14.2688 11.4998 14.1751L15.1364 15.9546L14.1593 12.8501C15.4772 11.7246 16.3127 10.0508 16.3127 8.18183C16.3127 4.79281 13.5654 2.04547 10.1764 2.04547H8.44911Z",
    stroke: "#C5C5C5",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02273 6.95459C6.58756 6.95459 7.04545 7.41248 7.04545 7.97732C7.04545 8.54215 6.58756 9.00004 6.02273 9.00004C5.45789 9.00004 5 8.54215 5 7.97732C5 7.41248 5.45789 6.95459 6.02273 6.95459ZM9.29545 6.95459C9.86029 6.95459 10.3182 7.41248 10.3182 7.97732C10.3182 8.54215 9.86029 9.00004 9.29545 9.00004C8.73062 9.00004 8.27273 8.54215 8.27273 7.97732C8.27273 7.41248 8.73062 6.95459 9.29545 6.95459ZM12.5682 6.95459C13.133 6.95459 13.5909 7.41248 13.5909 7.97732C13.5909 8.54215 13.133 9.00004 12.5682 9.00004C12.0033 9.00004 11.5455 8.54215 11.5455 7.97732C11.5455 7.41248 12.0033 6.95459 12.5682 6.95459Z",
    fill: "#C5C5C5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.388249bbdafa42468786442519bfd37e.svg";
export { ForwardRef as ReactComponent };